import { Component } from '@angular/core';
import {  NavController, NavParams,Nav } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { MyPosProvider } from '../../providers/my-pos/my-pos';
import { HomePage } from '../home/home';

import { Http} from "@angular/http";
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  nav: Nav;
  PasswordVal:any;
  NameVal:any;
  URLVal:any;
  list: Array<any>=[];
  constructor(public navCtrl: NavController, public navParams: NavParams,private storage: Storage
    ,public PosProvider:MyPosProvider,private http:Http
    ,public alertCtrl: AlertController,public loadingCtrl: LoadingController) {
    // set a key/value
  //storage.set('name', 'Max');

  // Or to get a key/value pair
  //storage.get('age').then((val) => {
  //  console.log('Your age is', val);
  //});  
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  
  save()
  {
    debugger;
    //-----
    let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
       //http://service.waheed-store.com
       this.PosProvider.MyDomain=this.URLVal;
       this.http.get(this.PosProvider.MyDomain+'/api/sense/GetLoginInfo/'+this.NameVal+'-'+this.PasswordVal)
       .map(res => res.json()).subscribe(data => {         
            this.list = data;
           let Loged:boolean=false;
           this.list.forEach(element => {
             if(element.IsAdmin =='True')
             {Loged=true;}
           });
        if(Loged)
        {
          debugger;
          this.storage.set('name', this.NameVal);
          this.PosProvider.UName=this.NameVal;
         this.storage.set('MyURL', this.URLVal);
          this.PosProvider.MyDomain=this.URLVal;
         
          this.navCtrl.setRoot(HomePage);
        }
        else
        {
          const alert = this.alertCtrl.create({
            title: 'رسالة خطأ',
            subTitle: 'تاكد من البيانات',
            buttons: ['OK']
          });
          alert.present();
        }
        
       loader.dismiss();
},err => {
  console.log(err);
  loader.dismiss();
  const alert = this.alertCtrl.create({
    title: 'Error message',
    subTitle: err,
    buttons: ['OK']
  });
  alert.present();
 });
    //----


   
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts